import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "./dashboard/Dashboard";
import Footer from "./Layout/Footer";
import Header from "./Layout/Header";
import Sidebar from "./Layout/Sidebar";
import Login from "./authentication/Login";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Forgotpassword from "./authentication/Forgotpassword";
import Slider from "./masterpages/Slider";
import AddSlider from "./masterpages/AddSlider";
import Project from "./masterpages/Project";
import AddProject from "./masterpages/AddProject";
import Blog from "./masterpages/Blog";
import AddBlog from "./masterpages/AddBlog";
import AddCounter from "./masterpages/AddCounter";
import Counter from "./masterpages/Counter";
import AddMileStone from "./masterpages/AddMileStone";
import Milestone from "./masterpages/Milestone";
import AddServices from "./masterpages/AddServices";
import Services from "./masterpages/Services";
import Menu from "./masterpages/Menu";
import AddMenu from "./masterpages/AddMenu";
import Setting from "./setting/Setting";
import ResetPassword from "./authentication/ResetPassword";
import ChangePasssword from "./authentication/ChangePasssword";
import EmailSetting from "./setting/EmailSetting";
import Contact from "./masterpages/Contact";
import Profile from "./masterpages/Profile";
import Testimonial from "./masterpages/Testimonial";
import AddTestimonial from "./masterpages/AddTestimonial";
import Awards from "./masterpages/Awards";
import AddAwards from "./masterpages/AddAwards";
import Leadership from "./masterpages/Leadership";
import AddLeadership from "./masterpages/AddLeadership";
import Contactview from "./masterpages/Contactview";
import Content from "./masterpages/Content";
import AddContent from "./masterpages/AddContent";
import "react-quill/dist/quill.snow.css";
import About from "./masterpages/About";
import AddAbout from "./masterpages/AddAbout";
import Projectdetails from "./masterpages/Projectdetails";
import AddProjectdetails from "./masterpages/AddProjectdetails";
import SocialMedia from "./masterpages/SocialMedia";
import AddSocialMedia from "./masterpages/AddSocialMedia";
import ProjectPlan from "./masterpages/ProjectPlan";
import AddProjectPlan from "./masterpages/AddProjectPlan";
import ProjectSpecification from "./masterpages/ProjectSpecification";
import AddProjectSpecification from "./masterpages/AddProjectSpecification";
import ProjectCounter from "./masterpages/ProjectCounter";
import AddProjectCounter from "./masterpages/AddProjectCounter";
import ProjectImages from "./masterpages/ProjectImages";
import AddProjectImages from "./masterpages/AddProjectImages";
import AboutSpecification from "./masterpages/AboutSpecification";
import AddAboutSpecification from "./masterpages/AddAboutSpecification";
import Career from "./masterpages/Career";
import Careerview from "./masterpages/Careerview";
import ProjectCategory from "./masterpages/ProjectCategory";
import AddProjectCategory from "./masterpages/AddProjectCategory";
import AddProjectContact from "./masterpages/AddProjectContact";
import ProjectContact from "./masterpages/ProjectContact";
import Banner from "./masterpages/Banner";
import AddBanner from "./masterpages/AddBanner";
import Inquiry from "./masterpages/Inquiry";
import Inquiryview from "./masterpages/Inquiryview";
import ProjectStatus from "./masterpages/ProjectStatus";
import AddProjectStatus from "./masterpages/AddProjectStatus";
import GalleryTab from "./masterpages/GalleryTab";
import AddGalleryTab from "./masterpages/AddGalleryTab";
import PlanTab from "./masterpages/PlanTab";
import AddPlanTab from "./masterpages/AddPlanTab";
import EmailTemplates from "./setting/EmailTemplates";
import ProjectCertificate from "./masterpages/ProjectCertificate";
import AddProjectCertificate from "./masterpages/AddProjectCertificate";
import ProjectVideo from "./masterpages/ProjectVideo";
import AddProjectVideo from "./masterpages/AddProjectVideo";
import Events from "./masterpages/Events";
import AddEvents from "./masterpages/AddEvents";

function RequireAuth({ children }) {
  let accessToken = localStorage.getItem("VacanzaDevAdminToken");
  if (!accessToken) {
    return <Navigate to="/" />;
  }
  return children;
}

function App() {
  let accessToken = localStorage.getItem("VacanzaDevAdminToken");

  return (
    <Router>
      <Routes>
        {!accessToken ? <Route path="/" element={<Login />} /> : ""}
        <Route path="/forgot-password" element={<Forgotpassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="*"
          element={
            <RequireAuth>
              <Header />
              <div className="container-scroller">
                <div className="container-fluid page-body-wrapper">
                  <Sidebar />
                  <div className="main-panel">
                    <Routes>
                      <Route path="/dashboard" element={<Dashboard />} />

                      <Route
                        path="/email-templates"
                        element={<EmailTemplates />}
                      />

                      <Route path="/slider" element={<Slider />} />
                      <Route path="/add-slider" element={<AddSlider />} />

                      <Route path="/banner" element={<Banner />} />
                      <Route path="/add-banner" element={<AddBanner />} />

                      <Route path="/project" element={<Project />} />
                      <Route path="/add-project" element={<AddProject />} />

                      <Route path="/blog" element={<Blog />} />
                      <Route path="/add-blog" element={<AddBlog />} />

                      <Route path="/events" element={<Events />} />
                      <Route path="/add-events" element={<AddEvents />} />

                      <Route path="/counter" element={<Counter />} />
                      <Route path="/add-counter" element={<AddCounter />} />

                      <Route path="/milestone" element={<Milestone />} />
                      <Route path="/add-milestone" element={<AddMileStone />} />

                      <Route path="/service" element={<Services />} />
                      <Route path="/add-service" element={<AddServices />} />

                      <Route path="/menu" element={<Menu />} />
                      <Route path="/add-menu" element={<AddMenu />} />

                      <Route path="/testimonial" element={<Testimonial />} />
                      <Route
                        path="/add-testimonial"
                        element={<AddTestimonial />}
                      />

                      <Route path="/awards" element={<Awards />} />
                      <Route path="/add-awards" element={<AddAwards />} />

                      <Route path="/leadership" element={<Leadership />} />
                      <Route
                        path="/add-leadership"
                        element={<AddLeadership />}
                      />

                      <Route path="/content" element={<Content />} />
                      <Route path="/add-content" element={<AddContent />} />

                      <Route path="/about" element={<About />} />
                      <Route path="/add-about" element={<AddAbout />} />

                      <Route
                        path="/project-details"
                        element={<Projectdetails />}
                      />
                      <Route
                        path="/add-project-details"
                        element={<AddProjectdetails />}
                      />

                      <Route path="/social-media" element={<SocialMedia />} />
                      <Route
                        path="/add-social-media"
                        element={<AddSocialMedia />}
                      />

                      <Route path="/plan" element={<ProjectPlan />} />
                      <Route path="/add-plan" element={<AddProjectPlan />} />

                      <Route
                        path="/specification"
                        element={<ProjectSpecification />}
                      />
                      <Route
                        path="/add-specification"
                        element={<AddProjectSpecification />}
                      />

                      <Route
                        path="/project-category"
                        element={<ProjectCategory />}
                      />
                      <Route
                        path="/add-category"
                        element={<AddProjectCategory />}
                      />

                      <Route
                        path="/project-status"
                        element={<ProjectStatus />}
                      />
                      <Route
                        path="/add-status"
                        element={<AddProjectStatus />}
                      />

                      <Route path="/gallery-tab" element={<GalleryTab />} />
                      <Route
                        path="/add-gallery-tab"
                        element={<AddGalleryTab />}
                      />

                      <Route path="/plan-tab" element={<PlanTab />} />
                      <Route path="/add-plan-tab" element={<AddPlanTab />} />

                      <Route
                        path="/project-counter"
                        element={<ProjectCounter />}
                      />
                      <Route
                        path="/add-project-counter"
                        element={<AddProjectCounter />}
                      />

                      <Route
                        path="/project-contact"
                        element={<ProjectContact />}
                      />
                      <Route
                        path="/add-project-contact"
                        element={<AddProjectContact />}
                      />

                      <Route
                        path="/project-certificate"
                        element={<ProjectCertificate />}
                      />
                      <Route
                        path="/add-project-certificate"
                        element={<AddProjectCertificate />}
                      />

                      <Route
                        path="/project-video"
                        element={<ProjectVideo />}
                      />
                      <Route
                        path="/add-project-video"
                        element={<AddProjectVideo />}
                      />

                      <Route
                        path="/project-gallery"
                        element={<ProjectImages />}
                      />
                      <Route
                        path="/add-project-gallery"
                        element={<AddProjectImages />}
                      />

                      <Route
                        path="/about-specification"
                        element={<AboutSpecification />}
                      />
                      <Route
                        path="/add-about-specification"
                        element={<AddAboutSpecification />}
                      />

                      <Route path="/projects-inquiry" element={<Inquiry />} />
                      <Route path="/view-inquiry" element={<Inquiryview />} />

                      <Route path="/site-settings" element={<Setting />} />
                      <Route
                        path="/change-password"
                        element={<ChangePasssword />}
                      />
                      <Route
                        path="/email-configuration"
                        element={<EmailSetting />}
                      />

                      <Route path="/contact-inquiry" element={<Contact />} />
                      <Route path="/view-contact" element={<Contactview />} />

                      <Route path="/careers" element={<Career />} />
                      <Route path="/view-career" element={<Careerview />} />

                      <Route path="/profile" element={<Profile />} />
                    </Routes>
                    <Footer />
                  </div>
                </div>
              </div>
            </RequireAuth>
          }
        />
      </Routes>
      <ToastContainer autoClose={1000} />
    </Router>
  );
}

export default App;
